import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNote2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconNote2"><Path d="M20.5 3.5H3.5V20.5H14L20.5 14V3.5Z" stroke="currentColor"/><Path d="M20 13.5H13.5V20" stroke="currentColor"/></CentralIconBase>;
});

export default IconNote2;
